<template>
  <span v-if="small">
    <v-btn
      fab
      small
      color="primary"
      :href="helpUrl"
      target="_blank"
    >
      <v-icon> bx bx-question-mark </v-icon>
    </v-btn>
  </span>
  <span v-else>
    <v-btn
      outlined
      color="primary"
      :href="helpUrl"
      target="_blank"
    >
      Help<v-icon right> bx bxs-help-circle </v-icon>
    </v-btn>
  </span>
</template>
<script>
export default {
  name: 'HelpButton',
  props: {
    helpUrl: { type: String, required: true },
    small: { type: Boolean, required: false, default: false }
  }
}
</script>
